<template>
    <div class="third">
        <div class="grid-list">
            <div class="grid-content">
                <div>
                    菜品销量(份)
                </div>
                <div>
                    {{ dataInfo.saleCount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    退菜数量(份)
                </div>
                <div>
                    {{ dataInfo.returnCount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    赠菜数量(份)
                </div>
                <div>
                    {{ dataInfo.presentCount }}
                </div>
            </div>

        </div>
        <span class="des">数据说明：同名菜品、同名菜品分类已合并统计</span>
        <div class="card-list">
            <el-card class="card-box">
                <div class="card-header">
                    <div class="card-header-left">
                        <el-image class="img" :src="require('@/assets/images/icon-tuicai.png')"></el-image>
                        <span>退菜菜品排行</span>

                    </div>
                </div>
                <div>
                    <el-table :data="tableData1" style="width: 100%" height="300px"
                        :header-cell-style="{ background: '#FFF' }">
                        <el-table-column type="index" width="80px" label="序号" align="center">
                            <template slot-scope="scope">

                                <span :class="{ 'hot-text': scope.$index < 3 }">{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productName" label="菜品名称" align="center"></el-table-column>
                        <el-table-column prop="returnCount" label="次数" width="120" align="center"></el-table-column>
                    </el-table>
                </div>
            </el-card>
            <el-card class="card-box">
                <div class="card-header">
                    <div class="card-header-left">
                        <el-image class="img" :src="require('@/assets/images/icon-hot.png')"></el-image>
                        <span>畅销菜品排行</span>
                    </div>
                </div>
                <div>
                    <el-table :data="tableData2" style="width: 100%" height="300px"
                        :header-cell-style="{ background: '#FFF' }">
                        <el-table-column type="index" width="80px" label="序号" align="center">
                            <template slot-scope="scope">

                                <span :class="{ 'hot-text': scope.$index < 3 }">{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productName" label="菜品名称" align="center"></el-table-column>
                        <el-table-column prop="saleAmount" label="销售额(元)" width="120" align="center"></el-table-column>
                    </el-table>
                </div>
            </el-card>
            <el-card class="card-box">
                <div class="card-header">
                    <div class="card-header-left">
                        <el-image class="img" :src="require('@/assets/images/icon-hot.png')"></el-image>
                        <span>畅销菜类排行</span>
                    </div>
                </div>
                <div>
                    <el-table :data="tableData3" style="width: 100%" height="300px"
                        :header-cell-style="{ background: '#FFF' }">
                        <el-table-column type="index" width="80px" label="序号" align="center">
                            <template slot-scope="scope">

                                <span :class="{ 'hot-text': scope.$index < 3 }">{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="categoryName" label="菜品名称" align="center"></el-table-column>
                        <el-table-column prop="saleAmount" label="销售额(元)" width="120" align="center"></el-table-column>
                    </el-table>
                </div>
            </el-card>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        dateTime: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            tableData1: [],
            tableData2: [],
            tableData3: [],
            dataInfo: {

            }
        };
    },
    methods: {
        async getData() {
            let startTime = null
            let endTime = null
            if (this.dateTime.length > 0) {
                startTime = this.dateTime[0]
                endTime = this.dateTime[1]
            }
            let params = {
                startTime: startTime,
                endTime: endTime,
                merchantCode: localStorage.getItem('merchantCode')
            }
            let res = await this.$http.post('/businessOverview/dishStatistics', params)
            if (res.data.code == 200) {
                this.dataInfo = res.data.data
            }
            let res2 = await this.$http.post('/businessOverview/dishRank', params)
            if (res2.data.code == 200) {
                this.tableData3 = res2.data.data.categoryRankList
                this.tableData2 = res2.data.data.saleRankList
                this.tableData1 = res2.data.data.returnRankList
            }
        }
    }
};
</script>

<style scoped lang="scss">
.third {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    margin: 20px auto;

    .grid-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        gap: 20px;
        width: 98%;

        .grid-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: start;
            height: 100px;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding-left: 20px;

            div:nth-child(1) {
                font-size: 16px;
                color: #999;
            }

            div:nth-child(2) {
                font-size: 28px;
                color: #333;
            }
        }
    }

    .des {
        display: block;
        font-size: 12px;
        color: #999;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .card-list {
        display: flex;
        justify-content: space-between;
        width: 98%;
        gap: 20px;

        .card-box {
            flex: 1;
            height: 400px;
            border-radius: 4px;

            .card-header {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .card-header-left {
                    display: flex;
                    align-items: center;

                    .img {
                        width: 20px;
                        height: 20px;
                    }

                    span {
                        margin-left: 4px;
                    }
                }
            }

        }
    }
}


.hot-text {
    color: rgb(254, 140, 0);
    font-weight: bold;

}
</style>